export default {
    page_title: "Kevi | Adicionar Cliente",
    title: "Adicionar Cliente",
    labels: {
        external_id: "ID Integracao",
        first_name: "Primeiro nome",
        last_name: "Sobrenome",
        whatsapp: "Celular",
        email: "E-mail",
        birthdate: "Data de nascimento",
        subscribe: "Enviar:",
    },
    placeholders: {
        whatsapp: "(##) #####-####",
        birthdate: "dd/mm/aaaa",
    },
    channels: {
        sms: "SMS",
        email: "E-mail",
        whatsapp: "WhatsApp",
    },
    errors: {
        invalid_phone: "Telefone invalido",
        duplicate_phone: "Ja existe um cliente com esse telefone",
        invalid_email: "Email invalido",
        duplicate_email: "Ja existe um cliente com esse email",
        invalid_birthdate: "Data invalida",
    },
    cancel: "Cancelar",
    save: "Salvar",
};
